






































import { computed, defineComponent, ref, watchEffect } from '@vue/composition-api';
import { DateRange } from '@/store/types';

const dateToInputValue = (date: Date | null) => date?.toISOString().split('T')[0] ?? '';

const getDefaultDateRange = (): DateRange => {
	const getBeginningOfDay = new Date(new Date().setHours(0, 0, 0, 0));
	const end = getBeginningOfDay;
	const start = new Date(end);
	start.setMonth(0, 1);
	return { start, end };
};

export default defineComponent({
	emits: ['ok'],
	props: {
		useDesktopLayout: {
			type: Boolean,
			default: false,
		},
	},
	setup(_, { root }) {
		const recentActivityFilter = computed(() => root.$store.getters['fieldsView/getRecentActivityFilter']);
		const recentActivityFilterDateRange = computed(
			() => root.$store.getters['fieldsView/getRecentActivityFilterDateRange']
		);
		const customPeriod = 'custom';
		const recentActivityPeriods = ['7', '30', '90'];
		const startDate = ref<string | null>(null);
		const endDate = ref<string | null>(null);

		const clearFilter = () => {
			root.$store.dispatch('fieldsView/setRecentActivityFilter', null);
		};

		const radioValue = computed<string | null>({
			get: () => {
				if (!recentActivityFilter.value) {
					return null;
				}
				// Custom
				if (recentActivityFilter.value.includes('-')) {
					// Restore start/end date if load from custom period
					if (!startDate.value && !endDate.value) {
						const { start, end } = recentActivityFilterDateRange.value;
						startDate.value = dateToInputValue(start);
						endDate.value = dateToInputValue(end);
					}
					return customPeriod;
				}
				// Common
				return recentActivityFilter.value;
			},
			set: (value) => {
				if (!value) {
					root.$store.dispatch('fieldsView/setRecentActivityFilter', null);
				} else if (value === customPeriod) {
					// both start and end must be specified as valid dates as iOS Safari does not render anything when the input's value is empty
					const { start, end } = getDefaultDateRange();
					startDate.value = dateToInputValue(start);
					endDate.value = dateToInputValue(end);
					root.$store.dispatch('fieldsView/setRecentActivityFilter', `${startDate.value}-${endDate.value}`);
				} else {
					root.$store.dispatch('fieldsView/setRecentActivityFilter', value);
				}
			},
		});

		watchEffect(() => {
			// Update recentActivityFilter if start or end date is changed
			if (radioValue.value === customPeriod && startDate.value && endDate.value) {
				root.$store.dispatch('fieldsView/setRecentActivityFilter', `${startDate.value}-${endDate.value}`);
			}
		});

		return {
			startDate,
			endDate,
			radioValue,
			customPeriod,
			recentActivityPeriods,
			dateToInputValue,
			clearFilter,
		};
	},
});
